import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { TextField, InputAdornment, Box } from "@mui/material";

const TableSearch = ({ onChange }) => {
  const [search, setSearch] = useState("");

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      onChange(search);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleTableSearch = (event) => {
    setSearch(event.target.value);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 300,
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="Search..."
        value={search}
        onChange={handleTableSearch}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "8px",

          "& .MuiOutlinedInput-root": {
            paddingRight: 0,
            "& fieldset": {
              borderColor: "#d0d0d0",
            },
            "&:hover fieldset": {
              borderColor: "#999",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
              borderWidth: "2px",
            },
          },

          // Placeholder style
          "& .MuiInputBase-input::placeholder": {
            color: "#9e9e9e",
            opacity: 1,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#616161" }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default TableSearch;
